import { createReducer, on } from '@ngrx/store';
import { SavedSearchState } from '../../models/states/saved-search-state.interfaces';
import * as fromSavedSearchActions from '../actions/saved-search.actions';

export const SavedSearchStateKey = 'savedSearch';

const initialState: SavedSearchState = {
  isReady: false,
  isError: false,
  savedSearchData: null
};

export const savedSearchReducer = createReducer(
  initialState,
  on(
    fromSavedSearchActions.LoadSavedSearchSuccess,
    (state, { savedSearchResponse }) => ({
      ...state,
      isReady: true,
      isError: savedSearchResponse.status === 'FAIL',
      savedSearchData: savedSearchResponse
    })
  ),
  on(fromSavedSearchActions.LoadSavedSearchFailure, (state) => ({
    ...state,
    isReady: false,
    isError: true
  }))
);
